import { Component, inject, TemplateRef } from '@angular/core';

import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeletePopupComponent } from '../common/delete-popup/delete-popup.component';
import { MatDialog } from '@angular/material/dialog';

export interface DialogData {
  animal: 'panda' | 'unicorn' | 'lion';
}

@Component({
  selector: 'app-recover-code',
  templateUrl: './recover-code.component.html',
  styleUrl: './recover-code.component.scss',

})

export class RecoverCodeComponent {
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
  };
  otp:any;
  constructor(public dialog: MatDialog) {}
  
  openDialog(event:Event) {
    // event.stopPropagation(); 
    event.preventDefault();
    this.dialog.open(DeletePopupComponent, {
      width: '480px',
      height:'365px',
      panelClass:'error-popup'
    });
  }
  onOtpChange(event: any) {
    this.otp = event;
  }
}


